// Copyright © 2024 Qcells. All rights reserved.
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
import { useStore } from 'vuex';
export const useSiteId = () => {
    const store = useStore();
    const siteId = store.state.siteNew.siteId;
    return { siteId };
};
